import { DateValue, getLocalTimeZone } from "@internationalized/date";
import { AppointmentSlotGroup } from "molecule/scheduler/SchedulerBloc";
import Scheduler from "molecule/scheduler/Scheduler";
import { FC, RefObject } from "react";
import { getSupportedUserLocale } from "src/lib/i18next";
import Translate from "../Translate/Translate";
import { AvailabilitySection } from "./AppointmentScheduler.styled";

const SlotAvailabilitySection: FC<{
  selectedDate: DateValue | undefined;
  availableSlotGroups: AppointmentSlotGroup[];
  sectionRef: RefObject<HTMLDivElement | null>;
}> = ({ selectedDate, availableSlotGroups, sectionRef }) => {
  if (!selectedDate || availableSlotGroups.length === 0) {
    return null;
  }

  return (
    <AvailabilitySection ref={sectionRef}>
      <h3>
        <Translate
          msg="appointment.schedule.available_on"
          variables={{
            date: selectedDate
              .toDate(getLocalTimeZone())
              .toLocaleDateString(getSupportedUserLocale(), {
                month: "short",
                weekday: "short",
                day: "numeric",
                year: "numeric"
              })
          }}
        />
      </h3>
      <Scheduler view="pick-slot" />
    </AvailabilitySection>
  );
};

export default SlotAvailabilitySection;
